import { __awaiter, __generator } from "tslib";
export var dynamicImportTranslatePlugin = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (rs, rj) {
                var script = document.createElement('script');
                script.src = 'https://static.ekuaibao.com/ekb/vendor-translate.1.0.6-release.0.147f6883.min.js';
                document.body.appendChild(script);
                script.onload = function () {
                    rs();
                };
                script.onerror = function (e) {
                    script.remove();
                    script.onerror = null;
                    rj(e);
                };
            })];
    });
}); };
